"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadData = downloadData;
const core_1 = require("@aws-amplify/core");
const downloadData_1 = require("../../providers/s3/apis/internal/downloadData");
function downloadData(ctxOrInput, maybeInput) {
    // Resolve the optional leading context. The global context is resolved at
    // CALL time (never cached) so single-arg callers follow live configuration.
    const [ctx, input] = (0, core_1.isAmplifyContext)(ctxOrInput)
        ? [ctxOrInput, maybeInput]
        : [(0, core_1.getGlobalContext)(), ctxOrInput];
    return (0, downloadData_1.downloadData)(ctx, {
        path: input.path,
        options: {
            useAccelerateEndpoint: input?.options?.useAccelerateEndpoint,
            bucket: input?.options?.bucket,
            locationCredentialsProvider: input?.options?.locationCredentialsProvider,
            bytesRange: input?.options?.bytesRange,
            onProgress: input?.options?.onProgress,
            expectedBucketOwner: input?.options?.expectedBucketOwner,
            customEndpoint: input?.options?.customEndpoint,
        },
        // Type casting is necessary because `downloadDataInternal` supports both Gen1 and Gen2 signatures, but here
        // given in input can only be Gen2 signature, the return can only ben Gen2 signature.
    });
}
